import React, { useEffect, useState } from 'react';
interface CountdownTimerProps {
  initialSeconds?: number;
  className?: string;
  compact?: boolean;
}
export function CountdownTimer({
  initialSeconds = 862,
  className = '',
  compact = false
}: CountdownTimerProps) {
  const [timeLeft, setTimeLeft] = useState(initialSeconds);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  if (compact) {
    return <div className={`flex items-center gap-1 ${className}`} data-id="element-1">
        {hours > 0 && <>
            <span className="countdown-digit text-sm" data-id="element-2">{pad(hours)}</span>
            <span className="text-amber-400 font-bold text-sm" data-id="element-3">:</span>
          </>}
        <span className="countdown-digit text-sm" data-id="element-4">{pad(minutes)}</span>
        <span className="text-amber-400 font-bold text-sm" data-id="element-5">:</span>
        <span className="countdown-digit text-sm" data-id="element-6">{pad(seconds)}</span>
      </div>;
  }
  return <div className={`flex items-center gap-2 ${className}`} data-id="element-7">
      {hours > 0 && <>
          <div className="flex flex-col items-center" data-id="element-8">
            <span className="countdown-digit text-xl md:text-2xl" data-id="element-9">
              {pad(hours)}
            </span>
            <span className="text-xs text-amber-600 mt-0.5 font-lato uppercase tracking-wider" data-id="element-10">
              hrs
            </span>
          </div>
          <span className="text-amber-400 font-bold text-xl pulse-ember" data-id="element-11">
            :
          </span>
        </>}
      <div className="flex flex-col items-center" data-id="element-12">
        <span className="countdown-digit text-xl md:text-2xl" data-id="element-13">
          {pad(minutes)}
        </span>
        <span className="text-xs text-amber-600 mt-0.5 uppercase tracking-wider" data-id="element-14">
          min
        </span>
      </div>
      <span className="text-amber-400 font-bold text-xl pulse-ember" data-id="element-15">:</span>
      <div className="flex flex-col items-center" data-id="element-16">
        <span className="countdown-digit text-xl md:text-2xl" data-id="element-17">
          {pad(seconds)}
        </span>
        <span className="text-xs text-amber-600 mt-0.5 uppercase tracking-wider" data-id="element-18">
          sec
        </span>
      </div>
    </div>;
}